import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState({ status: "polling", amount: null, tries: 0 });

  useEffect(() => {
    if (!sid) { setState({ status: "error" }); return; }
    let cancelled = false;
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setState({ status: "paid", amount: data.amount });
          return;
        }
        if (data.payment_status === "expired" || data.payment_status === "failed") {
          setState({ status: "failed" });
          return;
        }
      } catch (e) { /* retry */ }
      if (tries > 15) { setState({ status: "timeout" }); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  return (
    <div className="min-h-screen bg-blueprint flex items-center justify-center px-4">
      <div className="max-w-md w-full border border-white/10 bg-slate-950 p-10 text-center">
        {state.status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 text-kinetic mx-auto animate-spin" />
            <h1 className="font-display text-2xl font-black uppercase tracking-tight mt-6">Confirming your donation…</h1>
            <p className="text-slate-400 mt-2">Hang on &mdash; Stripe is handing us the receipt.</p>
          </>
        )}
        {state.status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-kinetic mx-auto" />
            <h1 className="font-display text-3xl font-black uppercase tracking-tight mt-6">You're on the van.</h1>
            <p className="text-slate-300 mt-3">
              Thank you — ${Number(state.amount || 0).toLocaleString()} received. Your name is now live on the Wall of Support.
            </p>
            <Link to="/" className="inline-block mt-8 px-6 py-3 bg-kinetic hover:bg-[#FF5E1A] text-black font-bold uppercase tracking-wide">
              Back to campaign
            </Link>
          </>
        )}
        {(state.status === "failed" || state.status === "timeout" || state.status === "error") && (
          <>
            <h1 className="font-display text-2xl font-black uppercase tracking-tight">Something didn&apos;t click.</h1>
            <p className="text-slate-400 mt-3">We couldn&apos;t confirm the payment. If your card was charged, it&apos;ll clear within a few minutes. Otherwise, try again.</p>
            <Link to="/" className="inline-block mt-6 px-6 py-3 border border-white/15 hover:bg-white/5 font-bold uppercase tracking-wide">
              Back to campaign
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
